import React from "react";
import timeFunction from "../../functions/getTime";
import { Link } from "react-router-dom";

/**
 * Hero news card — design/head new card.png
 *   normal : photo full-bleed, 272px orange panel (#FF4713 @ 80%) pinned right
 *   hover  : the panel expands over the whole card and the same text block
 *            slides to the left edge (wrap width stays identical)
 *   < sm   : the panel always covers the card (no hover on touch)
 */
export default function HeroCard(props) {
  const imageUrl =
    props.data && props.data.image && props.data.image[0]
      ? `${process.env.REACT_APP_API_URL}${props.data.image[0].url}`
      : "";

  const linkTo =
    props.page === "newsAndActivity/news"
      ? `/${props.lang}/${props.page}/${props.data?.slug}`
      : `/${props.lang}/article/${props.data?.slug}`;

  return (
    <Link
      to={linkTo}
      className="group relative block w-full h-[430px] rounded-[12px] overflow-hidden"
    >
      {/* Photo */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={
          imageUrl
            ? { backgroundImage: `url(${imageUrl})` }
            : { backgroundColor: "#D9D9D9" }
        }
      />

      {/* Orange panel */}
      <div className="absolute inset-y-0 right-0 w-full sm:w-[272px] group-hover:w-full bg-brand/80 transition-[width] duration-500 ease-in-out" />

      {/* Text block — same width in both states, only its position changes */}
      <div className="absolute top-[40px] sm:top-[48px] left-0 sm:left-[calc(100%_-_272px)] sm:group-hover:left-0 w-full sm:w-[272px] px-[24px] transition-[left] duration-500 ease-in-out">
        <h1 className="text-title font-normal text-white leading-[1.2] line-clamp-4">
          {props.lang === "th"
            ? props.data?.title?.detail_TH
            : props.data?.title?.detail_EN}
        </h1>
        <p className="text-body text-white mt-[14px]">
          {timeFunction.getTime(props.data?.publishedAt, props.lang)}
        </p>
      </div>
    </Link>
  );
}
